import { useEffect, useState } from "react";
import { IUser } from "src/components/shared/UserList/UserList.types";
import { useGetApi } from "src/hooks";
import { getYachtId } from "src/utils";

interface Props {
  unit: string | undefined;
  defaultUsers: IUser[];
}
/**
 * Custom hook to fetch and manage users based on the provided unit.
 *
 * @param props - An object containing the following properties:
 *   - unit: A string representing the unit type (e.g., "med", "olb").
 *   - defaultUsers: An array of default users to use when the unit is not "med"/"olb".
 * @returns An array of users fetched or the default users.
 */
export const useGetUsers = ({ unit, defaultUsers }: Props) => {
  const [users, setUsers] = useState<IUser[]>([]);
  const { refetch: refetchMed } = useGetApi({
    request: "get-med-users",
    body: {
      params: {
        yachtid: getYachtId(),
      },
    },
    fetchOnInit: false,
  });
  const { refetch: refetchOlb } = useGetApi({
    request: "get-olb-users",
    body: {
      params: {
        yachtid: getYachtId(),
      },
    },
    fetchOnInit: false,
  });

  useEffect(() => {
    (async () => {
      if (unit?.includes("med")) {
        const data = await refetchMed();
        setUsers(data?.list ?? []);
      } else if (unit === "userrefpopiom") {
        const data = await refetchOlb();
        setUsers(data?.list ?? []);
      } else {
        setUsers(defaultUsers);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [unit, defaultUsers]);

  return users;
};
export default useGetUsers;
